import axios from 'axios';

export default class DeepgramSpeechProvider {
	init(config) {
		this.config = config;
		this.isSocket = true;//!!config?.isSocket;
	}

	initWhisper(callback, language) {
		navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
			if (!MediaRecorder.isTypeSupported('audio/webm'))
				return;

			const mediaRecorder = this.mediaRecorder = new MediaRecorder(stream, {
				mimeType: 'audio/webm',
			});
			
			mediaRecorder.addEventListener('dataavailable', async (event) => {
				var formData = new FormData();
				formData.append('data-binary', event.data);
				axios.post('https://api.deepgram.com/v1/listen?model=whisper', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Content-Type:': 'audio/webm'
					}
				}).then(r => {
					if (__DEBUG__) {
						console.debug('Whisper response', { r });
					}
				})
			})
			mediaRecorder.start(3000);
		});
	}

	initSocket(callback, language) {
		if (__DEBUG__)
			console.debug('Init deepgram socket', { cfg: this.config });

		this.stopMicRecognition();
		const socket = this.socket = new WebSocket(`wss://api.deepgram.com/v1/listen?language=${language || 'en-US'}&tier=enhanced`, [
			'token',
			this.config.DeepgramApiKey
		]);
		navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
			if (!MediaRecorder.isTypeSupported('audio/webm'))
				return;

			const mediaRecorder = new MediaRecorder(stream, {
				mimeType: 'audio/webm',
			});
			
			socket.onopen = () => {
				if (__DEBUG__)
					console.log({ event: 'onopen' })
				mediaRecorder.addEventListener('dataavailable', async (event) => {
					if (event.data.size > 0 && socket.readyState == 1) {
						socket.send(event.data)
					}
				})
				mediaRecorder.start(1000);
			}
	
			socket.onmessage = (message) => {
				const received = JSON.parse(message.data);
				const transcript = received.channel.alternatives[0].transcript;
				const status = received.is_final ? 1 : 0;
				const response = {
					text: transcript,
					status,
					recognizing: status === 0,
					result: received
				};

				if (!response.text) return;

				if (__DEBUG__)
					console.log(`%cRecognized`, `padding: 4px; background: ${response.recognizing ? '#dedede' : '#5599ff'}; color: #333`, response);

				if (callback) {
					callback(response);
				}
			}
	
			socket.onclose = () => {
				if (__DEBUG__)
					console.log({ event: 'onclose' })
			}
	
			socket.onerror = (error) => {
				if (__DEBUG__)
					console.log({ event: 'onerror', error })
			}
		});
	}
	
	startMicRecognition(callback, once, language) {
		if (__DEBUG__)
			console.log(`%cStart deepgram speech recognition`, 'padding: 4px; background: #5599ff; color: #333');
		
		if (this.isSocket) {
			this.initSocket((response) => {
				if (once && response?.status === 1) {
					if (callback)
						callback(response);
					this.stopMicRecognition();
				} else {
					if (callback)
						callback(response);
				}
			}, language);
		} else {
			this.initWhisper((response) => {
				if (once && response?.status === 1) {
					if (callback)
						callback(response);
					this.stopMicRecognition();
				} else {
					if (callback)
						callback(response);
				}
			})
		}
	}
	
	stopMicRecognition() {
		if (this.isSocket) {
			const socket = this.socket;
			if (socket) {
				socket.close();
				setImmediate(() => {
					if (socket?.terminate && [socket.OPEN, socket.CLOSING].includes(socket.readyState)) {
						socket.terminate();
					}

				});

				this.socket = null;
			}
		} else {
			if (this.mediaRecorder) {
				this.mediaRecorder.stop();
			}
			delete this.mediaRecorder;
		}
	}
}